import { render } from "./RevisiPenyusunanDokumenPengadaanForm.vue?vue&type=template&id=b0844cee"
import script from "./RevisiPenyusunanDokumenPengadaanForm.vue?vue&type=script&lang=js"
export * from "./RevisiPenyusunanDokumenPengadaanForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__